import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["companyUrl"];
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { trackCustomMarketplaceOfferingBehavioralEvent } from 'marketplace-ui-common/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SolutionsPartnerProfileCTAButton(_ref) {
  let {
      companyUrl
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackInteraction
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsx(Button, Object.assign({
    external: true,
    href: companyUrl,
    onClick: () => {
      trackInteraction({
        action: 'click contact button'
      });
      trackCustomMarketplaceOfferingBehavioralEvent('PRIMARY_CTA');
    },
    rel: "noopener",
    target: "_blank",
    use: "primary"
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.contact"
    })
  }));
}